"use client"

import { Header } from "@/components/header"
import { Footer } from "@/components/footer"
import { EnquirySidebar } from "@/components/enquiry-sidebar"
import { OnlineAdmissionForm } from "@/components/online-admission-form"

export default function SchoolAdmissionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="container mx-auto px-4 py-8">
        <OnlineAdmissionForm />
      </div>

      <Footer />
    </div>
  )
}
